import React, {useEffect, useState} from 'react'
import FlipNumbers from "react-flip-numbers";


const FlipAnimation = (props) => {
	const {value,color,pixel} = props
	const [count, setCount] = useState(value>10?Math.round((value/2)/2):0);
	let counter
	useEffect(() => {

		if (value > count) {
			counter = setInterval(() => {
				setCount(count + 1)
				return count
			}, 50)
		}

		return () => {
			clearInterval(counter)
		};
	}, [count]);
	return (

		<div>
			<FlipNumbers
				play
				color={color}
				background="#ffffff00"
				width={pixel/2}
				height={pixel}
				numbers={`${count}`}/>
		</div>
	)
}

export default FlipAnimation
//
// import React from "react";
// import {numberFormat} from "../util";
// import FlipNumbers from "react-flip-numbers";
//
// class FlipAnimation extends React.Component {
// 	state = {
// 		timeRemaining: 0
// 	};
//
//
//
// 	componentDidMount() {
//
// 		this.timer = setInterval(() => {
// 			if (this.state.timeRemaining < this.props.amount_value){
// 				this.setState({
// 					timeRemaining: this.state.timeRemaining + 99
// 				});
// 		}
// 		}, 1);
// 	}
//
// 	componentWillUnmount() {
// 		clearInterval(this.timer);
// 	}
//
// 	render() {
// 		console.log(this.state.timeRemaining)
// 		console.log(this.props.amount_value)
// 		return (
// 			<div>
//
// 				<FlipNumbers
// 					play
// 					color={this.props.color}
// 					background="#333333"
// 					width={50}
// 					height={50}
// 					numbers={`${numberFormat(this.state.timeRemaining)}`}
// 				/>
//
// 			</div>
// 		);
// 	}
// }
//
// // const rootElement = document.getElementById("root");
// // ReactDOM.render(<App />, rootElement);
// export default FlipAnimation